<section class="ds-modal customer-edit-modal" aria-labelledby="customer_edit_modal_title">
    <div class="customer-edit-modal__header">
        <div class="ds-modal__header">
            <ds-text id="customer_edit_modal_title" size="xl" theme="primary" weight="medium">{{ modalTitle }}</ds-text>
        </div>

        <ds-icon-button size="md" theme="secondary-gray" icon="close" (buttonClick)="onClose()"></ds-icon-button>
    </div>

    <form class="ds-modal__content ds-modal__content--scrollable customer-edit-modal__form" [formGroup]="form" novalidate>
        <div class="customer-edit-modal__grid">
            <ds-input id="customerName" label="Name *" placeholder="Customer Name" formControlName="name" [maxlength]="nameMaxLength">
                <mat-error *ngIf="form.controls.name.hasError('required')">Customer Name is required.</mat-error>
            </ds-input>

            <ds-select id="customerType" label="Type *" placeholder="Select Type" formControlName="customerType">
                <mat-option *ngFor="let type of customerTypes" [value]="type.customerTypeName">{{ type.customerTypeName }}</mat-option>

                <mat-error *ngIf="form.controls.customerType.hasError('required')">Type is required.</mat-error>
            </ds-select>

            <ds-input
                id="primaryContact"
                autocomplete="tel"
                label="Phone *"
                placeholder="(xxx) xxx-xxxx"
                formControlName="phone"
                [maxlength]="phoneMaxLength"
                (focusout)="onPhoneBlur()"
            >
                <mat-error *ngIf="form.controls.phone.hasError('required')">Phone Number is required.</mat-error>
                <mat-error *ngIf="form.controls.phone.hasError('pattern')">Phone must have 10 digits.</mat-error>
            </ds-input>

            <ds-input id="email" label="Email" placeholder="Email" formControlName="emailId" [maxlength]="emailMaxLength"></ds-input>

            <div class="customer-edit-modal__po">
                <ds-input id="poBox" class="customer-edit-modal__po-field" label="PO #" [disabled]="true" [value]="poBoxValue"></ds-input>

                <ds-icon-button
                    class="customer-edit-modal__po-button"
                    size="md"
                    theme="secondary-gray"
                    icon="add_circle"
                    matTooltip="Add PO#"
                    (buttonClick)="openPoMappingModal()"
                ></ds-icon-button>
            </div>

            <ds-select id="region" label="Region" placeholder="None" formControlName="region">
                <mat-option *ngFor="let region of regionOptions" [disabled]="region.isDisabled" [value]="region.name">
                    {{ region.name }}
                </mat-option>
            </ds-select>

            <div class="customer-edit-modal__field">
                <ds-text size="sm" weight="medium" text="Contracted Customer"></ds-text>

                <ds-radio-group formControlName="isContracted" [options]="contractedOptions"></ds-radio-group>
            </div>

            <ds-select id="groundResponseTime" label="Contracted Response Time for Ground" formControlName="groundResponseTime">
                <mat-option
                    *ngFor="let groundResponse of groundResponseTimeOptions"
                    [disabled]="groundResponse.isDisabled"
                    [value]="groundResponse.value"
                >
                    {{ groundResponse.name }}
                </mat-option>
            </ds-select>
        </div>

        <div class="customer-edit-modal__field customer-edit-modal__field--full">
            <ds-text
                size="sm"
                weight="medium"
                text="Associated Business Emails"
                title="Enter comma separated business emails without any space."
            ></ds-text>

            <mat-form-field class="ds-form-control__item" appearance="outline" subscriptSizing="dynamic">
                <textarea
                    id="associatedEmails"
                    matInput
                    rows="4"
                    formControlName="businessEmail"
                    placeholder="Enter Business Emails"
                    (change)="onBusinessEmailChange()"
                ></textarea>
            </mat-form-field>

            <!-- Not a `mat-error`: the textarea is valid as far as the form is concerned, the flag is ours. -->
            <ds-text
                *ngIf="invalidEmail"
                color="var(--tac-primary-text-color-invalid)"
                role="alert"
                size="sm"
                text="Invalid Associated Emails."
            ></ds-text>
        </div>

        <ds-divider></ds-divider>

        <div class="customer-edit-modal__grid" formGroupName="address">
            <ds-select id="addressType" label="Address Type" placeholder="Select Address Type" formControlName="addressLocationType">
                <mat-option *ngFor="let addressType of addressTypes" [value]="addressType">{{ addressType }}</mat-option>
            </ds-select>

            <div class="customer-edit-modal__field">
                <ds-text size="sm" weight="medium" text="Address"></ds-text>

                <ds-radio-group formControlName="isGlobal" [options]="addressVisibilityOptions"></ds-radio-group>
            </div>

            <ds-input
                id="CMStreetAddress"
                placeholder="Street Address"
                formControlName="streetAddress"
                [label]="isAddressTypeSelected ? 'Street Address *' : 'Street Address'"
                [maxlength]="streetAddressMaxLength"
            >
                <mat-error *ngIf="form.controls.address.controls.streetAddress.hasError('required')">Field is required.</mat-error>
            </ds-input>

            <ds-input
                id="CMzipCode"
                placeholder="zipCode"
                formControlName="zipcode"
                [label]="isAddressTypeSelected ? 'Zipcode *' : 'Zipcode'"
                [maxlength]="zipcodeMaxLength"
            >
                <mat-error *ngIf="form.controls.address.controls.zipcode.hasError('required')">Field is required.</mat-error>
                <mat-error *ngIf="form.controls.address.controls.zipcode.hasError('pattern')">ZipCode not valid.</mat-error>
                <mat-error *ngIf="form.controls.address.controls.zipcode.hasError('minlength')">
                    ZipCode must have 3 or 5 digits.
                </mat-error>
            </ds-input>

            <ds-select
                id="state"
                placeholder="Select State"
                formControlName="stateId"
                [label]="isAddressTypeSelected ? 'State *' : 'State'"
                (selectionChange)="onStateChange()"
            >
                <mat-option *ngFor="let state of stateList" [value]="state.stateId">{{ state?.stateName }}</mat-option>

                <mat-error *ngIf="form.controls.address.controls.stateId.hasError('required')">State is required.</mat-error>
            </ds-select>

            <ds-select id="city" placeholder="Select City" formControlName="city" [label]="isAddressTypeSelected ? 'City *' : 'City'">
                <mat-option *ngFor="let city of cityList" [value]="city.cityName">{{ city.cityName }}</mat-option>

                <mat-error *ngIf="form.controls.address.controls.city.hasError('required')">City is required.</mat-error>
            </ds-select>
        </div>
    </form>

    <div class="ds-modal__footer customer-edit-modal__footer">
        <ds-button label="Cancel" size="sm" theme="secondary-gray" (buttonClick)="onClose()"></ds-button>
        <ds-button label="Save Changes" size="sm" theme="primary" [isLoading]="isSaving" (buttonClick)="onSave()"></ds-button>
    </div>
</section>
